import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { sanitizeApiErrorBody } from '@core/http/api-error-message';

export const apiErrorSanitizerInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (!error.error || typeof error.error !== 'object') {
        return throwError(() => error);
      }

      const sanitizedBody = sanitizeApiErrorBody(error.error);

      if (sanitizedBody === error.error) {
        return throwError(() => error);
      }

      return throwError(
        () =>
          new HttpErrorResponse({
            error: sanitizedBody,
            headers: error.headers,
            status: error.status,
            statusText: error.statusText,
            url: error.url ?? undefined,
          }),
      );
    }),
  );
};
